export default {
    errorMessage: 'Error message',
    somethingWrong: 'Something Wrong!!',
    close: 'Close'
}
